import React from 'react'

const Social = () => {
  return (
    <div className='home_social'>
        <a href="https://www.instagram.com" className='home_social-icon' target='_blank' rel="noreferrer"><i class="uil uil-instagram"></i></a>
        <a href="https://dribble.com" className='home_social-icon' target='_blank' rel="noreferrer"><i class="uil uil-dribbble"></i></a>
        <a href="https://github.com" className='home_social-icon' target='_blank' rel="noreferrer"><i class="uil uil-github-alt"></i></a>

      
    </div>
  )
}

export default Social
